import { useState, useEffect, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

export function useReferrals() {
  const [referrals, setReferrals] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchReferrals = useCallback(() => {
    setLoading(true);
    quarkusApi
      .get('/leads-by-clinic', { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => setReferrals(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.message);
        console.error(returnFromApi);
        setReferrals([]);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchReferrals();
  }, [fetchReferrals]);

  return { referrals, isLoading, error, refetch: fetchReferrals };
}
